import React, { createContext, useContext } from 'react';

/** Refetch the current lazy-loaded communities list (e.g. All Communities). */
export type CommunitiesListRefetchFn = () => void | Promise<void>;

const CommunitiesListRefreshContext =
  createContext<CommunitiesListRefetchFn | null>(null);

export function CommunitiesListRefreshProvider({
  children,
  refetch,
}: {
  children: React.ReactNode;
  refetch: CommunitiesListRefetchFn;
}) {
  return (
    <CommunitiesListRefreshContext.Provider value={refetch}>
      {children}
    </CommunitiesListRefreshContext.Provider>
  );
}

/** Present only under pages that wrap the list with `CommunitiesListRefreshProvider`. */
export function useOptionalCommunitiesListRefresh() {
  return useContext(CommunitiesListRefreshContext);
}
